import React, {useEffect, useRef, useState} from "react";
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './App.scss'
import Header from './components/header'
import Welcome from './components/welcome'
import Search from './components/search'
import WhoWeAre from './components/whoWeAre'
import Spacer from './components/spacer'
import Sponsors from './components/sponsors'
import HowToBuy from './components/howToBuy'
import Suscribe from './components/suscribe'
import HowToSell from './components/howToSell'
import Testimonials from './components/testimonials/testimonials'
import LatestNews from './components/latestNews'
import GetInTouch from './components/getIntouch'
import Footer from './components/footer'
import Faqs from "./components/faqs/faqs";
import ContactUs from "./components/contactUs/contactUs";
import ScrollToTop from "./components/scrollToTopWrapper";
import NotFound from "./components/notFoundLink";
import {BrowserRouter as Router, Routes, Route, useParams, useHistory } from 'react-router-dom'
import Terms from "./components/terms/terms";
import AboutUs from "./components/aboutUs/aboutUs";
import LanguageSelector from "./components/langSelector";
import WhatsappContact from "./components/whatsappContact";
import BusinessList from "./components/businessAvailableList/businessList";
import BusinessDetail from "./components/businessDetail/businessDetail";
import User from "./components/user/user";
import Quotation from "./components/quotation/quotation";
import QuotationBusinessUpdate from "./components/quotation/quotationUpdate";
import i18n from "./i18n";
import Dashboard from "./components/user/dashboard/dashboard";
import Blog from "./components/blog/blog";
import BlogDetail from "./components/blog/blog.details/blog.detail";
import Payment from "./components/payment/payment";
import {useNavigate} from "react-router";
import TestimonialsPage from "./components/testimonials/testimonials.page";
import cookie from 'react-cookies'
import HelmetHeaders from "./components/helmetHeaders";
import StructuredData from "./components/structuredData";
import {
    buildAboutPageSchema,
    buildBlogCollectionPageSchema,
    buildCollectionPageSchema,
    buildContactPageSchema,
    buildFaqSchema,
    buildHomeSchemas,
    buildHowToBuySchema,
    buildHowToSellSchema,
    buildWebPageSchema,
} from "./components/structuredData.schemas";

function App() {

    const [language, setLanguage] = useState('es')

    useEffect(() => {
        document.documentElement.lang = language === 'pt' ? 'pt-BR' : 'es'
    }, [language])

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setLanguage(lng);
    };

    const removeFilterCookies = () => {
        cookie.remove('sdt_marketplace_type');
        cookie.remove('sdt_marketplace_category');
        cookie.remove('sdt_country');
        cookie.remove('sdt_search_text');
        cookie.remove('sdt_current_business_list_page');
        cookie.remove('sdt_order_by');
        cookie.remove('sdt_manual_quotation_price');
        cookie.remove('sdt_reset_form');
        cookie.remove('sdt_marketplace_intermediation');
    }

    return (
        <>
            <Router>
                <LanguageSelector changeLanguage={changeLanguage} language={language}/>
                <ScrollToTop>



                <Routes>
                        <Route element={<Header language={language} />}>
                        <Route exact path="/" element={<Home title={i18n.t("section-titles.home")} description={i18n.t("section-titles.home_desc")} language={language} />} />
                        {/*<Route path="/:newLang" element={<Home title={i18n.t("section-titles.home")} description={i18n.t("section-titles.home_desc")} />} /> */}
                        <Route path="/negocios-disponibles" element={<BusinessListSection title={i18n.t("section-titles.businessListSection")} description={i18n.t("section-titles.businessListSection_desc")}  />} />
                        <Route path="/negocios-disponibles/:searchText/:countryId" element={<BusinessListSearchSection  title={i18n.t("section-titles.businessListSection")} description={i18n.t("section-titles.businessListSection_desc")}  />} />
                        <Route path="/negocios-disponibles/:marketPlaceType" element={<BusinessListMarketplaceSection  title={i18n.t("section-titles.businessListSection")} description={i18n.t("section-titles.businessListSection_desc")}  />} />
                        <Route path="/contacto" element={<ContactUsSection  title={i18n.t("section-titles.contactUsSection")} description={i18n.t("section-titles.contactUsSection_desc")} />} />
                        <Route path="/testimonios" element={<TestimonialsSection title={i18n.t("section-titles.testimonialsSection")} description={i18n.t("section-titles.testimonialsSection_desc")} />} />
                        <Route path="/blog" element={<BlogSection title={i18n.t("section-titles.blogSection")} description={i18n.t("section-titles.blogSection_desc")} />} />
                        <Route path="/prensa" element={<NewsSection  title={i18n.t("section-titles.newsSection")} description={i18n.t("section-titles.newsSection_desc")}/>} />
                        <Route path="/:type/:blogId" element={<BlogDetailSection  />} />
                        <Route path="/vende-tu-negocio" element={<QuotationSection  title={i18n.t("section-titles.quotationSection")} description={i18n.t("section-titles.quotationSection_desc")} />} />
                        <Route path="/vende-tu-negocio-update/:businessId/:businessToken" element={<QuotationUpdateSection  title={i18n.t("section-titles.quotationSection")} description={i18n.t("section-titles.quotationUpdateSection_desc")} />} />
                        <Route path="/vende-tu-negocio-pagos/:id/:update_token" element={<PaymemntSection title={i18n.t("section-titles.paymentSection")} description={i18n.t("section-titles.paymentSection_desc")} />} />
                        <Route path="/precios" element={<PricesSection title={i18n.t("section-titles.pricesSection")} description={i18n.t("section-titles.pricesSection_desc")} />} />
                        <Route path="/usuario/panel" element={<DashboardSection title={i18n.t("section-titles.dashboardSection")} description={i18n.t("section-titles.dashboardSection_desc")}/>} />
                        <Route path="/preguntas-frecuentes" element={<FaqsSection title={i18n.t("section-titles.faqs")} description={i18n.t("section-titles.faqs_desc")} />} />
                        <Route path="/preguntas-frecuentes/:type" element={<FaqsTypeSection title_buyer={i18n.t("section-titles.faqs_buyer")} title_seller={i18n.t("section-titles.faqs_seller")} description_buyer={i18n.t("section-titles.faqs_buyer_desc")} description_seller={i18n.t("section-titles.faqs_seller_desc")} />} />
                        <Route path="/quienes-somos" element={<AboutUsSection title={i18n.t("section-titles.aboutUsSection")} description={i18n.t("section-titles.aboutUsSection_desc")}/>} />
                        <Route path="/como-vender" element={<HowToSellSection title={i18n.t("section-titles.howToSellSection")} description={i18n.t("section-titles.howToSellSection_desc")}/>} />
                        <Route path="/como-comprar" element={<HowToBuySection title={i18n.t("section-titles.howToBuySection")} description={i18n.t("section-titles.howToBuySection_desc")}/>} />
                        <Route path="/negocio/:businessId" element={<BusinessDetailSection/>} />
                        <Route path="*" element={<NotFoundSection title={i18n.t("section-titles.notFound")}/>} />
                        <Route path="/no-encontrado" element={<NotFoundSection title={i18n.t("section-titles.notFound")}/>} />
                    </Route>

                    <Route path="/usuario/*" element={<UserSection title={'Login'}/>} />

                </Routes>

                <Footer
                    language={language}
                />
                </ScrollToTop>
                <Terms language={language}/>
                {/*<WhatsappContact />*/}
            </Router>



        </>
    )


function Home(props) {
    const {newLang} = useParams();
    const navigate = useNavigate();
    removeFilterCookies();

    useEffect(() => {
        if(newLang==='es' || newLang=='pt'){
            changeLanguage(newLang)
            navigate('/', { replace: true });
        }
    }, [newLang])

    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildHomeSchemas()} />
        <Welcome />
        <Search language={language} fromHome={ true }/>
        <Spacer multiplier={6} />
        <WhoWeAre language={props.language} />
        <Sponsors />
        <HowToBuy isHome={true} />
        <Suscribe language={language}/>
        <HowToSell isHome={true} />
        <Testimonials language={language}/>
        <LatestNews language={language}/>
        <GetInTouch language={language}/>
        </>
}

function PaymemntSection(props) {
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} noIndex={true} />
        <Payment language={language}/>
        </>
}

function PricesSection(props) {
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildWebPageSchema({ name: props.title, description: props.description })} />
        <Payment language={language} />
        </>
}

function TestimonialsSection(props){
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildWebPageSchema({ name: props.title, description: props.description })} />
        <TestimonialsPage language={language}/>
    </>
}

function DashboardSection(props){
    return <>
        <HelmetHeaders title={props.title} description={props.description} noIndex={true} />
        <Dashboard language={language}/>
    </>
}

function FaqsSection(props) {
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={[
            buildWebPageSchema({ name: props.title, description: props.description }),
            buildFaqSchema(),
        ]} />
        <Faqs type="vendedor" language={language}/>
        <Suscribe />
        <GetInTouch language={language}/>
    </>
}

function BusinessDetailSection(props) {
    const {businessId} = useParams();
    return <>
        {/* Los headers se encuentran dentro del componente BusinessDetail */}
        <BusinessDetail businessId={businessId} language={language}/>
    </>
}

function FaqsTypeSection(props) {
    removeFilterCookies();
    const {type} = useParams();
    return <>
        <HelmetHeaders
            title={type === "comprador" ? props.title_buyer : props.title_seller}
            description={type === "comprador" ? props.description_buyer : props.description_seller}
            noIndex={true}
        />
        <Faqs type={type} language={language}/>
        <Suscribe />
        <GetInTouch language={language}/>
    </>
}

function ContactUsSection(props) {
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildContactPageSchema({ name: props.title, description: props.description, language })} />
        <ContactUs language={language}/>
    </>
}

function BusinessListSection(props){
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildCollectionPageSchema({ name: props.title, description: props.description })} />
        <BusinessList language={language}/>
    </>
}

function BusinessListSearchSection(props){
    return <>
        <HelmetHeaders title={props.title} description={props.description} noIndex={true} />
        <BusinessList language={language}/>
    </>
}

function BusinessListMarketplaceSection(props){
    const {marketPlaceType} = useParams();
    return <>
        <HelmetHeaders title={props.title} description={props.description} noIndex={true} />
        <BusinessList marketPlaceType={marketPlaceType}  language={language}/>
    </>
}

function BlogSection(props){
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildBlogCollectionPageSchema({ name: props.title, description: props.description, type: 'blog' })} />
        <Blog language={language} type={"blog"}/>
    </>
}

function NewsSection(props){
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildBlogCollectionPageSchema({ name: props.title, description: props.description, type: 'prensa' })} />
        <Blog language={language} type={"prensa"}/>
    </>
}

function BlogDetailSection(props){
    const {blogId} = useParams();
    removeFilterCookies();
    return <>
        {/* Los headers se encuentran dentro del componente BlogDetail*/}
        <BlogDetail blogId={blogId} language={language}/>
    </>
}

function AboutUsSection(props){
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildAboutPageSchema({ name: props.title, description: props.description })} />
        <AboutUs language={language}/>
    </>
}

function UserSection(props){
    {/* Los headers se encuentran dentro del componente User */}
    return <>
        <User language={language} />
    </>
}

function HowToBuySection(props) {
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={[
            buildWebPageSchema({ name: props.title, description: props.description }),
            buildHowToBuySchema(),
        ]} />
        <HowToBuy />
    </>
}


function HowToSellSection(props) {
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={[
            buildWebPageSchema({ name: props.title, description: props.description }),
            buildHowToSellSchema(),
        ]} />
        <HowToSell />
    </>
}

function QuotationSection(props) {
    removeFilterCookies();
    return <>
        <HelmetHeaders title={props.title} description={props.description} />
        <StructuredData data={buildWebPageSchema({ name: props.title, description: props.description })} />
        <Quotation language={language}/>
    </>
}

    function QuotationUpdateSection(props) {
            const {businessId, businessToken} = useParams();
        return <>
            <HelmetHeaders title={props.title} description={props.description} noIndex={true} />
            <QuotationBusinessUpdate businessId={businessId} businessToken={businessToken} language={language}/>
        </>
    }


function NotFoundSection(props) {
    return <>
        <HelmetHeaders title={props.title} noIndex={true} />
        <NotFound />
    </>
}


}


export default App
